var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.menu != undefined
    ? _c(
        "li",
        [
          _vm.menu.children != undefined
            ? [
                _c("div", { staticClass: "tit" }, [
                  _vm._v(
                    _vm._s(
                      _vm.menu.meta.key !== undefined
                        ? _vm.$t(_vm.menu.meta.key)
                        : _vm.menu.meta.breadcrumb
                    )
                  ),
                ]),
                _c(
                  "ul",
                  [
                    _vm._l(_vm.menu.children, function (vo, idx) {
                      return [
                        (
                          vo.meta.sitemapHide
                            ? false
                            : vo.meta.serviceLangs
                            ? vo.meta.serviceLangs.includes(_vm.serviceLang)
                            : true && vo.meta.serviceCtrCds
                            ? vo.meta.serviceCtrCds.includes(
                                _vm.memberDetail.userCtrCd
                              )
                            : true && vo.meta.intergisLvs
                            ? vo.meta.intergisLvs.includes(_vm.intergisLv)
                            : true
                        )
                          ? _c(
                              "li",
                              {
                                key: "menu_" + idx,
                                class: {
                                  site_depth2: vo.children != undefined,
                                },
                              },
                              [
                                vo.children == undefined
                                  ? _c(
                                      "a",
                                      {
                                        class:
                                          vo.children != undefined
                                            ? "sub_list"
                                            : "",
                                        attrs: { href: `#${_vm.menu.path}` },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.go(
                                              _vm.menu.path + "/" + vo.path,
                                              vo
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            vo.meta.key !== undefined
                                              ? _vm.$t(vo.meta.key)
                                              : vo.meta.breadcrumb
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                vo.children != undefined
                                  ? _c(
                                      "span",
                                      { on: { click: _vm.openSubmenu } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            vo.meta.key !== undefined
                                              ? _vm.$t(vo.meta.key)
                                              : vo.meta.breadcrumb
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                vo.children != undefined
                                  ? _c(
                                      "ul",
                                      { staticClass: "site_depth2_child" },
                                      [
                                        _vm._l(
                                          vo.children,
                                          function (svo, sidx) {
                                            return [
                                              (
                                                svo.meta.sitemapHide
                                                  ? false
                                                  : svo.meta.serviceLangs
                                                  ? svo.meta.serviceLangs.includes(
                                                      _vm.serviceLang
                                                    )
                                                  : true && svo.meta.intergisLvs
                                                  ? svo.meta.intergisLvs.includes(
                                                      _vm.intergisLv
                                                    )
                                                  : true
                                              )
                                                ? _c(
                                                    "li",
                                                    { key: "sub_menu_" + sidx },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: `#${_vm.menu.path}`,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              _vm.$router
                                                                .push(
                                                                  _vm.menu
                                                                    .path +
                                                                    "/" +
                                                                    vo.path +
                                                                    "/" +
                                                                    svo.path
                                                                )
                                                                .catch(() => {})
                                                              _vm.$emit("click")
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              svo.meta.key !==
                                                                undefined
                                                                ? _vm.$t(
                                                                    svo.meta.key
                                                                  )
                                                                : svo.meta
                                                                    .breadcrumb
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        [
                          _c(
                            "li",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.menu.path === "/my-info" &&
                                    _vm.menu.children.length - 1 === idx,
                                  expression:
                                    "menu.path === '/my-info' && menu.children.length -1 === idx",
                                },
                              ],
                              key: "menu_2" + idx,
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: `#${_vm.menu.path}` },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.goManual.apply(null, arguments)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("menu.MENU09.140")))]
                              ),
                            ]
                          ),
                        ],
                        [
                          _c(
                            "li",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.menu.path === "/my-info" &&
                                    _vm.menu.children.length - 1 === idx &&
                                    _vm.kmtcSpotCoupon === "Y",
                                  expression:
                                    "menu.path === '/my-info' && menu.children.length -1 === idx && kmtcSpotCoupon === 'Y'",
                                },
                              ],
                              key: "menu_3" + idx,
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: `#${_vm.menu.path}` },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.goPromotion.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("menu.MENU09.142")))]
                              ),
                            ]
                          ),
                        ],
                      ]
                    }),
                  ],
                  2
                ),
              ]
            : [
                _c("div", { staticClass: "tit" }, [
                  _vm._v(
                    _vm._s(
                      _vm.menu.meta.key !== undefined
                        ? _vm.$t(_vm.menu.meta.key)
                        : _vm.menu.meta.breadcrumb
                    )
                  ),
                ]),
                _c("ul", [
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { href: `#${_vm.menu.path}` },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.$router.push(_vm.menu.path).catch(() => {})
                            _vm.$emit("click")
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.menu.meta.key !== undefined
                              ? _vm.$t(_vm.menu.meta.key)
                              : _vm.menu.meta.breadcrumb
                          )
                        ),
                      ]
                    ),
                  ]),
                ]),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }